
<div class="login-wrapper">
  <div class="login-container">
    <div class="login-logo">
      <img src="https://royall444.com/api/users/images/theme-1742469725615-royal444.png" alt="Royal 444 Logo">
    </div>
    
    <div class="close-btn" routerLink="/home">
      <i class="fas fa-times"></i>
    </div>
    
    <form class="login-form">
      <div class="input-group">
        <input type="text" placeholder="Username" class="form-control">
        <div class="input-icon"><i class="fas fa-user"></i></div>
      </div>
      
      <div class="input-group">
        <input type="password" placeholder="Password" class="form-control">
        <div class="input-icon"><i class="fas fa-eye-slash"></i></div>
      </div>
      
      <button type="button" class="btn btn-login">Login</button>
      <button type="button" class="btn btn-demo">Login with Demo ID</button>
    </form>
  </div>
</div>
